"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardDeleteButton = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../reducers/slices/main");
var checkout_1 = require("../../reducers/slices/checkout");
var delete_card_vault_1 = require("../../api/calls/payment-engine/paygate/delete_card_vault");
var get_card_vault_1 = require("../../api/calls/payment-engine/paygate/get_card_vault");
var CardDeleteButton = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var index = props.index, id = props.id;
    if (index < 0 || !id)
        return null;
    var _a = (0, react_1.useState)(-1), deletingIndex = _a[0], setDeletingIndex = _a[1];
    var _b = (0, react_1.useState)(false), isDeleting = _b[0], setIsDeleting = _b[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var getBankCards = function () {
        var _a;
        (0, get_card_vault_1.get_card_vault)({
            integration_id: (_a = user._id) !== null && _a !== void 0 ? _a : "",
        }).then(function (response) {
            if (response.success) {
                dispatch((0, checkout_1.setBankCards)(response.content.result));
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    };
    var Confirmation = function () {
        var onConfirm = function () {
            setIsDeleting(true);
            setDeletingIndex(index);
            (0, delete_card_vault_1.delete_card_vault)({
                card_id: id,
            }).then(function (response) {
                setIsDeleting(false);
                setDeletingIndex(-1);
                if (response.success) {
                    getBankCards();
                    dispatch((0, main_1.setContentModal)(null));
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Something went wrong!",
                        messages: [response.message],
                    }));
                }
            });
        };
        return (react_1.default.createElement("div", { className: "flex flex-col justify-center text-center" },
            react_1.default.createElement("div", { className: "mb-3" }, "Are you sure you want to remove this card?"),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Remove Card", backgroundColor: "bg-primary", onClick: onConfirm })));
    };
    return (react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faTrash, backgroundColor: "bg-error", iconColor: "text-white", size: "xsmall", loading: index == deletingIndex && isDeleting, onClick: function () {
            dispatch((0, main_1.setContentModal)({
                title: "Delete Card",
                content: react_1.default.createElement(Confirmation, null),
            }));
        } }));
};
exports.CardDeleteButton = CardDeleteButton;
